/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TimeZoneOffsetsEnums {
    EASTERN_ST = -5,
    EASTERN_DT = -4,
    CENTRAL_ST = -6,
    CENTRAL_DT = -5,
    MOUNTAIN_ST = -7,
    MOUNTAIN_DT = -6,
    PACIFIC_ST = -8,
    PACIFIC_DT = -7,
    ALASKA_ST = -9,
    ALASKA_DT = -8,
    HAWAII_ST = -10,
    HAWAII_DT = -9,
}
